import React from 'react';

const CartItemOverMax = ({ maxQuantity }) => {
  return (
    <div className="caption mt-0.5 text-error">
      {window.TMW.Strings.cart.maxQuantityError?.replace('{quantity}', maxQuantity)}
    </div>
  );
};

export default CartItemOverMax;
